import qs from 'qs';
import store from '../../../config/redux/store';
import { stateToQuery } from '../reducers';
import { getSearchPath } from '../../../routes/config';
import type { FilterSet, RequestState } from '../types';

export function getSearchPathWithRequest(request: RequestState = store.getState().request): string {
  return getSearchPath({ ...stateToQuery(request), page: 1 });
}

export function getRequestQueryString(request: RequestState = store.getState().request): string {
  const query = stateToQuery(request);
  return `?${qs.stringify(query, { arrayFormat: 'brackets' })}`;
}

export function isFilterActive(filterSet: FilterSet): boolean {
  return (
    filterSet.accommodation_type.length > 0 ||
    filterSet.bathrooms > 1 ||
    filterSet.bedrooms > 1 ||
    filterSet.amenities.length > 0 ||
    filterSet.distance_to_beach > 0 ||
    filterSet.stars > 0
  );
}

export default { getSearchPathWithRequest };
